module.exports = __webpack_public_path__ + "static/media/icons_youtubewhite.bdf40a45.svg";